module.exports = __webpack_public_path__ + "img/ex7_3.prt.56fb37d2.jpg";